export default class Code{
	constructor(text, code) {
	    this.text = text
		this.code = code
	}
}